import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { crmApi, type Customer } from '../../api/crm';

export function Customer360Page() {
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [profile, setProfile] = useState<unknown>(null);

  useEffect(() => {
    void crmApi.listCustomers().then(setCustomers);
  }, []);

  async function load360(id: string) {
    setProfile(await crmApi.getCustomer360(id));
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/customers" className="text-sm text-slate-600 hover:underline">← CRM hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Customer 360 profile</h1>
      <ul className="mt-4 space-y-2">
        {customers.map((c) => (
          <li key={c.id}>
            <button type="button" onClick={() => void load360(c.id)}
              className="rounded border px-3 py-2 text-sm">View 360 — {c.customer_code}</button>
          </li>
        ))}
      </ul>
      {profile != null && (
        <pre className="mt-4 overflow-auto rounded border p-3 text-xs">{JSON.stringify(profile, null, 2)}</pre>
      )}
    </div>
  );
}
